'use strict';

var ProductService = /*@ngInject*/ function(
  $http,
  REST_URL
) {
  var _self = this;

  _self.getProductDetails = function(productId) {
    return $http.get(REST_URL.products + `/by-product-id/${productId}/details`);
  };

};

module.exports = ProductService;
